export default __webpack_public_path__ + "static/media/환자용_정기상담.5aa55d01.png";